import { render, staticRenderFns } from "./EditAndDeleteAccount.vue?vue&type=template&id=6bcb9129&scoped=true&"
import script from "./EditAndDeleteAccount.vue?vue&type=script&lang=js&"
export * from "./EditAndDeleteAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcb9129",
  null
  
)

export default component.exports